import { useEffect, useState } from "react";
import { useNavigate, Outlet, NavLink } from "react-router-dom";
import api from "../lib/api";
import { LogOut, Calendar, Sparkles, Utensils, LayoutDashboard, Image, CalendarOff, Settings, Ticket, Clock, Send } from "lucide-react";

export default function AdminLayout() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => nav("/admin/login"))
      .finally(() => setChecking(false));
  }, [nav]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("hc_token");
    nav("/admin/login");
  };

  if (checking) return <div className="min-h-screen flex items-center justify-center bg-[#FAF4F1]">Loading…</div>;
  if (!user) return null;

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm transition-colors ${
      isActive ? "bg-[#E05947] text-white" : "text-[#2D3748] hover:bg-[#FAF4F1]"
    }`;

  return (
    <div className="min-h-screen bg-[#FAF4F1] flex flex-col lg:flex-row" data-testid="admin-layout">
      <aside className="lg:w-64 bg-white border-b lg:border-b-0 lg:border-r border-[#F0EAE6] p-5 lg:p-6">
        <div className="flex items-center gap-3 mb-7">
          <img src="/images/logo.png" alt="" className="h-10 w-10 rounded-full bg-[#FAF4F1] p-1" />
          <div>
            <div className="font-serif-display text-lg text-[#5979A9]">Himalayan</div>
            <div className="text-xs text-[#4A5568]">Admin Panel</div>
          </div>
        </div>
        <nav className="flex flex-row lg:flex-col gap-2 overflow-x-auto">
          <NavLink end to="/admin" className={linkCls} data-testid="admin-nav-dashboard"><LayoutDashboard size={16}/> Dashboard</NavLink>
          <NavLink to="/admin/offers" className={linkCls} data-testid="admin-nav-offers"><Sparkles size={16}/> Offers</NavLink>
          <NavLink to="/admin/menu" className={linkCls} data-testid="admin-nav-menu"><Utensils size={16}/> Menu</NavLink>
          <NavLink to="/admin/gallery" className={linkCls} data-testid="admin-nav-gallery"><Image size={16}/> Gallery</NavLink>
          <NavLink to="/admin/reservations" className={linkCls} data-testid="admin-nav-reservations"><Calendar size={16}/> Reservations</NavLink>
          <NavLink to="/admin/availability" className={linkCls} data-testid="admin-nav-availability"><CalendarOff size={16}/> Availability</NavLink>
          <NavLink to="/admin/hours" className={linkCls} data-testid="admin-nav-hours"><Clock size={16}/> Hours</NavLink>
          <NavLink to="/admin/events" className={linkCls} data-testid="admin-nav-events"><Ticket size={16}/> Events</NavLink>
          <NavLink to="/admin/telegram" className={linkCls} data-testid="admin-nav-telegram"><Send size={16}/> Telegram</NavLink>
          <NavLink to="/admin/settings" className={linkCls} data-testid="admin-nav-settings"><Settings size={16}/> Settings</NavLink>
        </nav>
        <button onClick={logout} data-testid="admin-logout-button" className="mt-6 hidden lg:flex items-center gap-2 text-sm text-[#4A5568] hover:text-[#E05947]">
          <LogOut size={16}/> Sign out
        </button>
      </aside>
      <main className="flex-1 p-5 sm:p-8 lg:p-10 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
